var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomepageHeroHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1439,
    height: 249,
    viewBox: "0 0 1439 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_49233)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_184_49233",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -655,
    y: -159,
    width: 2235,
    height: 428
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1579 -159H-654.305V268.76H1579V-159Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_184_49233)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_184_49233",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -655,
    y: -153,
    width: 2231,
    height: 353
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1575.51 -152.026H-654.305V199.018H1575.51V-152.026Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_184_49233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1423.14 192.043H1420.81V194.368H1423.14V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.3 192.043H1364.97V194.368H1367.3V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.47 192.043H1309.14V194.368H1311.47V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.64 192.043H1253.31V194.368H1255.64V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.8 192.043H1197.48V194.368H1199.8V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.97 192.043H1141.65V194.368H1143.97V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.14 192.043H1085.81V194.368H1088.14V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.3 192.043H1029.98V194.368H1032.3V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.475 192.043H974.148V194.368H976.475V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.643 192.043H918.317V194.368H920.643V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.806 192.043H862.479V194.368H864.806V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.974 192.043H806.648V194.368H808.974V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.146 192.043H750.82V194.368H753.146V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.309 192.043H694.982V194.368H697.309V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.477 192.043H639.151V194.368H641.477V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.643 192.043H583.317V194.368H585.643V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.81 192.043H527.484V194.368H529.81V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.98 192.043H471.654V194.368H473.98V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.146 192.043H415.819V194.368H418.146V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.313 192.043H359.987V194.368H362.313V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.482 192.043H304.155V194.368H306.482V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.649 192.043H248.323V194.368H250.649V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.814 192.043H192.488V194.368H194.814V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.985 192.043H136.658V194.368H138.985V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1502 192.043H80.8239V194.368H83.1502V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3174 192.043H24.9911V194.368H27.3174V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.14 136.248H1420.81V138.573H1423.14V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.3 136.248H1364.97V138.573H1367.3V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.47 136.248H1309.14V138.573H1311.47V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.64 136.248H1253.31V138.573H1255.64V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.8 136.248H1197.48V138.573H1199.8V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.97 136.248H1141.65V138.573H1143.97V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.14 136.248H1085.81V138.573H1088.14V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.3 136.248H1029.98V138.573H1032.3V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.475 136.248H974.148V138.573H976.475V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.643 136.248H918.317V138.573H920.643V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.806 136.248H862.479V138.573H864.806V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.974 136.248H806.648V138.573H808.974V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.146 136.248H750.82V138.573H753.146V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.309 136.248H694.982V138.573H697.309V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.477 136.248H639.151V138.573H641.477V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.643 136.248H583.317V138.573H585.643V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.81 136.248H527.484V138.573H529.81V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.98 136.248H471.654V138.573H473.98V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.146 136.248H415.819V138.573H418.146V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.313 136.248H359.987V138.573H362.313V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.482 136.248H304.155V138.573H306.482V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.649 136.248H248.323V138.573H250.649V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.814 136.248H192.488V138.573H194.814V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.985 136.248H136.658V138.573H138.985V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1502 136.248H80.8239V138.573H83.1502V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3174 136.248H24.9911V138.573H27.3174V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.14 80.4529H1420.81V82.7777H1423.14V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.3 80.4529H1364.97V82.7777H1367.3V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.47 80.4529H1309.14V82.7777H1311.47V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.64 80.4529H1253.31V82.7777H1255.64V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.8 80.4529H1197.48V82.7777H1199.8V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.97 80.4529H1141.65V82.7777H1143.97V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.14 80.4529H1085.81V82.7777H1088.14V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.3 80.4529H1029.98V82.7777H1032.3V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.475 80.4529H974.148V82.7777H976.475V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.643 80.4529H918.317V82.7777H920.643V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.806 80.4529H862.479V82.7777H864.806V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.974 80.4529H806.648V82.7777H808.974V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.146 80.4529H750.82V82.7777H753.146V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.309 80.4529H694.982V82.7777H697.309V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.477 80.4529H639.151V82.7777H641.477V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.643 80.4529H583.317V82.7777H585.643V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.81 80.4529H527.484V82.7777H529.81V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.98 80.4529H471.654V82.7777H473.98V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.146 80.4529H415.819V82.7777H418.146V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.313 80.4529H359.987V82.7777H362.313V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.482 80.4529H304.155V82.7777H306.482V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.649 80.4529H248.323V82.7777H250.649V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.814 80.4529H192.488V82.7777H194.814V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.985 80.4529H136.658V82.7777H138.985V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1502 80.4529H80.8239V82.7777H83.1502V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3174 80.4529H24.9911V82.7777H27.3174V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.14 24.6582H1420.81V26.983H1423.14V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.3 24.6582H1364.97V26.983H1367.3V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.47 24.6582H1309.14V26.983H1311.47V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.64 24.6582H1253.31V26.983H1255.64V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.8 24.6582H1197.48V26.983H1199.8V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.97 24.6582H1141.65V26.983H1143.97V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.14 24.6582H1085.81V26.983H1088.14V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.3 24.6582H1029.98V26.983H1032.3V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.475 24.6582H974.148V26.983H976.475V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.643 24.6582H918.317V26.983H920.643V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.806 24.6582H862.479V26.983H864.806V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.974 24.6582H806.648V26.983H808.974V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.146 24.6582H750.82V26.983H753.146V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.309 24.6582H694.982V26.983H697.309V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.477 24.6582H639.151V26.983H641.477V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.643 24.6582H583.317V26.983H585.643V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.81 24.6582H527.484V26.983H529.81V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.98 24.6582H471.654V26.983H473.98V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.146 24.6582H415.819V26.983H418.146V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.313 24.6582H359.987V26.983H362.313V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.482 24.6582H304.155V26.983H306.482V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.649 24.6582H248.323V26.983H250.649V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.814 24.6582H192.488V26.983H194.814V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.985 24.6582H136.658V26.983H138.985V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1502 24.6582H80.8239V26.983H83.1502V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3174 24.6582H24.9911V26.983H27.3174V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.22 192.043H1392.89V194.368H1395.22V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.38 192.043H1337.06V194.368H1339.38V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.55 192.043H1281.23V194.368H1283.55V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.72 192.043H1225.39V194.368H1227.72V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.89 192.043H1169.56V194.368H1171.89V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.06 192.043H1113.73V194.368H1116.06V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.22 192.043H1057.89V194.368H1060.22V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.39 192.043H1002.06V194.368H1004.39V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.56 192.043H946.233V194.368H948.56V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.722 192.043H890.396V194.368H892.722V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.89 192.043H834.564V194.368H836.89V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.062 192.043H778.736V194.368H781.062V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.225 192.043H722.898V194.368H725.225V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.393 192.043H667.067V194.368H669.393V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.56 192.043H611.233V194.368H613.56V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.727 192.043H555.4V194.368H557.727V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.897 192.043H499.57V194.368H501.897V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.062 192.043H443.736V194.368H446.062V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.229 192.043H387.903V194.368H390.229V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.398 192.043H332.072V194.368H334.398V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.565 192.043H276.239V194.368H278.565V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.731 192.043H220.404V194.368H222.731V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.901 192.043H164.575V194.368H166.901V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.066 192.043H108.74V194.368H111.066V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2337 192.043H52.9073V194.368H55.2337V192.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.22 136.248H1392.89V138.573H1395.22V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.38 136.248H1337.06V138.573H1339.38V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.55 136.248H1281.23V138.573H1283.55V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.72 136.248H1225.39V138.573H1227.72V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.89 136.248H1169.56V138.573H1171.89V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.06 136.248H1113.73V138.573H1116.06V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.22 136.248H1057.89V138.573H1060.22V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.39 136.248H1002.06V138.573H1004.39V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.56 136.248H946.233V138.573H948.56V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.722 136.248H890.396V138.573H892.722V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.89 136.248H834.564V138.573H836.89V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.062 136.248H778.736V138.573H781.062V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.225 136.248H722.898V138.573H725.225V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.393 136.248H667.067V138.573H669.393V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.56 136.248H611.233V138.573H613.56V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.727 136.248H555.4V138.573H557.727V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.897 136.248H499.57V138.573H501.897V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.062 136.248H443.736V138.573H446.062V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.229 136.248H387.903V138.573H390.229V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.398 136.248H332.072V138.573H334.398V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.565 136.248H276.239V138.573H278.565V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.731 136.248H220.404V138.573H222.731V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.901 136.248H164.575V138.573H166.901V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.066 136.248H108.74V138.573H111.066V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2337 136.248H52.9073V138.573H55.2337V136.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.22 80.4529H1392.89V82.7777H1395.22V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.38 80.4529H1337.06V82.7777H1339.38V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.55 80.4529H1281.23V82.7777H1283.55V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.72 80.4529H1225.39V82.7777H1227.72V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.89 80.4529H1169.56V82.7777H1171.89V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.06 80.4529H1113.73V82.7777H1116.06V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.22 80.4529H1057.89V82.7777H1060.22V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.39 80.4529H1002.06V82.7777H1004.39V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.56 80.4529H946.233V82.7777H948.56V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.722 80.4529H890.396V82.7777H892.722V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.89 80.4529H834.564V82.7777H836.89V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.062 80.4529H778.736V82.7777H781.062V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.225 80.4529H722.898V82.7777H725.225V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.393 80.4529H667.067V82.7777H669.393V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.56 80.4529H611.233V82.7777H613.56V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.727 80.4529H555.4V82.7777H557.727V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.897 80.4529H499.57V82.7777H501.897V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.062 80.4529H443.736V82.7777H446.062V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.229 80.4529H387.903V82.7777H390.229V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.398 80.4529H332.072V82.7777H334.398V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.565 80.4529H276.239V82.7777H278.565V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.731 80.4529H220.404V82.7777H222.731V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.901 80.4529H164.575V82.7777H166.901V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.066 80.4529H108.74V82.7777H111.066V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2337 80.4529H52.9073V82.7777H55.2337V80.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.22 24.6582H1392.89V26.983H1395.22V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.38 24.6582H1337.06V26.983H1339.38V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.55 24.6582H1281.23V26.983H1283.55V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.72 24.6582H1225.39V26.983H1227.72V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.89 24.6582H1169.56V26.983H1171.89V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.06 24.6582H1113.73V26.983H1116.06V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.22 24.6582H1057.89V26.983H1060.22V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.39 24.6582H1002.06V26.983H1004.39V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.56 24.6582H946.233V26.983H948.56V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.722 24.6582H890.396V26.983H892.722V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.89 24.6582H834.564V26.983H836.89V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.062 24.6582H778.736V26.983H781.062V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.225 24.6582H722.898V26.983H725.225V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.393 24.6582H667.067V26.983H669.393V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.56 24.6582H611.233V26.983H613.56V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.727 24.6582H555.4V26.983H557.727V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.897 24.6582H499.57V26.983H501.897V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.062 24.6582H443.736V26.983H446.062V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.229 24.6582H387.903V26.983H390.229V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.398 24.6582H332.072V26.983H334.398V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.565 24.6582H276.239V26.983H278.565V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.731 24.6582H220.404V26.983H222.731V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.901 24.6582H164.575V26.983H166.901V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.066 24.6582H108.74V26.983H111.066V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2337 24.6582H52.9073V26.983H55.2337V24.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.14 164.146H1420.81V166.47H1423.14V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.3 164.146H1364.97V166.47H1367.3V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.47 164.146H1309.14V166.47H1311.47V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.64 164.146H1253.31V166.47H1255.64V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.8 164.146H1197.48V166.47H1199.8V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.97 164.146H1141.65V166.47H1143.97V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.14 164.146H1085.81V166.47H1088.14V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.3 164.146H1029.98V166.47H1032.3V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.475 164.146H974.148V166.47H976.475V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.643 164.146H918.317V166.47H920.643V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.806 164.146H862.479V166.47H864.806V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.974 164.146H806.648V166.47H808.974V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.146 164.146H750.82V166.47H753.146V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.309 164.146H694.982V166.47H697.309V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.477 164.146H639.151V166.47H641.477V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.643 164.146H583.317V166.47H585.643V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.81 164.146H527.484V166.47H529.81V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.98 164.146H471.654V166.47H473.98V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.146 164.146H415.819V166.47H418.146V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.313 164.146H359.987V166.47H362.313V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.482 164.146H304.155V166.47H306.482V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.649 164.146H248.323V166.47H250.649V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.814 164.146H192.488V166.47H194.814V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.985 164.146H136.658V166.47H138.985V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1502 164.146H80.8239V166.47H83.1502V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3174 164.146H24.9911V166.47H27.3174V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.14 108.35H1420.81V110.675H1423.14V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.3 108.35H1364.97V110.675H1367.3V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.47 108.35H1309.14V110.675H1311.47V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.64 108.35H1253.31V110.675H1255.64V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.8 108.35H1197.48V110.675H1199.8V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.97 108.35H1141.65V110.675H1143.97V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.14 108.35H1085.81V110.675H1088.14V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.3 108.35H1029.98V110.675H1032.3V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.475 108.35H974.148V110.675H976.475V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.643 108.35H918.317V110.675H920.643V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.806 108.35H862.479V110.675H864.806V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.974 108.35H806.648V110.675H808.974V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.146 108.35H750.82V110.675H753.146V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.309 108.35H694.982V110.675H697.309V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.477 108.35H639.151V110.675H641.477V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.643 108.35H583.317V110.675H585.643V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.81 108.35H527.484V110.675H529.81V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.98 108.35H471.654V110.675H473.98V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.146 108.35H415.819V110.675H418.146V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.313 108.35H359.987V110.675H362.313V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.482 108.35H304.155V110.675H306.482V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.649 108.35H248.323V110.675H250.649V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.814 108.35H192.488V110.675H194.814V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.985 108.35H136.658V110.675H138.985V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1502 108.35H80.8239V110.675H83.1502V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3174 108.35H24.9911V110.675H27.3174V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.14 52.5556H1420.81V54.8804H1423.14V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.3 52.5556H1364.97V54.8804H1367.3V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.47 52.5556H1309.14V54.8804H1311.47V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.64 52.5556H1253.31V54.8804H1255.64V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.8 52.5556H1197.48V54.8804H1199.8V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.97 52.5556H1141.65V54.8804H1143.97V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.14 52.5556H1085.81V54.8804H1088.14V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.3 52.5556H1029.98V54.8804H1032.3V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.475 52.5556H974.148V54.8804H976.475V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.643 52.5556H918.317V54.8804H920.643V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.806 52.5556H862.479V54.8804H864.806V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.974 52.5556H806.648V54.8804H808.974V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.146 52.5556H750.82V54.8804H753.146V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.309 52.5556H694.982V54.8804H697.309V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.477 52.5556H639.151V54.8804H641.477V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.643 52.5556H583.317V54.8804H585.643V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.81 52.5556H527.484V54.8804H529.81V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.98 52.5556H471.654V54.8804H473.98V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.146 52.5556H415.819V54.8804H418.146V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.313 52.5556H359.987V54.8804H362.313V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.482 52.5556H304.155V54.8804H306.482V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.649 52.5556H248.323V54.8804H250.649V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.814 52.5556H192.488V54.8804H194.814V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.985 52.5556H136.658V54.8804H138.985V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1502 52.5556H80.8239V54.8804H83.1502V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3174 52.5556H24.9911V54.8804H27.3174V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.22 164.146H1392.89V166.47H1395.22V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.38 164.146H1337.06V166.47H1339.38V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.55 164.146H1281.23V166.47H1283.55V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.72 164.146H1225.39V166.47H1227.72V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.89 164.146H1169.56V166.47H1171.89V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.06 164.146H1113.73V166.47H1116.06V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.22 164.146H1057.89V166.47H1060.22V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.39 164.146H1002.06V166.47H1004.39V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.56 164.146H946.233V166.47H948.56V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.722 164.146H890.396V166.47H892.722V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.89 164.146H834.564V166.47H836.89V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.062 164.146H778.736V166.47H781.062V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.225 164.146H722.898V166.47H725.225V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.393 164.146H667.067V166.47H669.393V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.56 164.146H611.233V166.47H613.56V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.727 164.146H555.4V166.47H557.727V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.897 164.146H499.57V166.47H501.897V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.062 164.146H443.736V166.47H446.062V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.229 164.146H387.903V166.47H390.229V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.398 164.146H332.072V166.47H334.398V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.565 164.146H276.239V166.47H278.565V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.731 164.146H220.404V166.47H222.731V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.901 164.146H164.575V166.47H166.901V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.066 164.146H108.74V166.47H111.066V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2337 164.146H52.9073V166.47H55.2337V164.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.22 108.35H1392.89V110.675H1395.22V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.38 108.35H1337.06V110.675H1339.38V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.55 108.35H1281.23V110.675H1283.55V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.72 108.35H1225.39V110.675H1227.72V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.89 108.35H1169.56V110.675H1171.89V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.06 108.35H1113.73V110.675H1116.06V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.22 108.35H1057.89V110.675H1060.22V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.39 108.35H1002.06V110.675H1004.39V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.56 108.35H946.233V110.675H948.56V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.722 108.35H890.396V110.675H892.722V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.89 108.35H834.564V110.675H836.89V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.062 108.35H778.736V110.675H781.062V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.225 108.35H722.898V110.675H725.225V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.393 108.35H667.067V110.675H669.393V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.56 108.35H611.233V110.675H613.56V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.727 108.35H555.4V110.675H557.727V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.897 108.35H499.57V110.675H501.897V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.062 108.35H443.736V110.675H446.062V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.229 108.35H387.903V110.675H390.229V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.398 108.35H332.072V110.675H334.398V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.565 108.35H276.239V110.675H278.565V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.731 108.35H220.404V110.675H222.731V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.901 108.35H164.575V110.675H166.901V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.066 108.35H108.74V110.675H111.066V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2337 108.35H52.9073V110.675H55.2337V108.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.22 52.5556H1392.89V54.8804H1395.22V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.38 52.5556H1337.06V54.8804H1339.38V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.55 52.5556H1281.23V54.8804H1283.55V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.72 52.5556H1225.39V54.8804H1227.72V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.89 52.5556H1169.56V54.8804H1171.89V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.06 52.5556H1113.73V54.8804H1116.06V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.22 52.5556H1057.89V54.8804H1060.22V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.39 52.5556H1002.06V54.8804H1004.39V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.56 52.5556H946.233V54.8804H948.56V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.722 52.5556H890.396V54.8804H892.722V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.89 52.5556H834.564V54.8804H836.89V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.062 52.5556H778.736V54.8804H781.062V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.225 52.5556H722.898V54.8804H725.225V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.393 52.5556H667.067V54.8804H669.393V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.56 52.5556H611.233V54.8804H613.56V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.727 52.5556H555.4V54.8804H557.727V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.897 52.5556H499.57V54.8804H501.897V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.062 52.5556H443.736V54.8804H446.062V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.229 52.5556H387.903V54.8804H390.229V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.398 52.5556H332.072V54.8804H334.398V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.565 52.5556H276.239V54.8804H278.565V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.731 52.5556H220.404V54.8804H222.731V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.901 52.5556H164.575V54.8804H166.901V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.066 52.5556H108.74V54.8804H111.066V52.5556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2337 52.5556H52.9073V54.8804H55.2337V52.5556Z",
    fill: "black"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1339.39 193.207C1308.55 193.207 1283.55 168.227 1283.55 137.412H1227.72C1227.72 199.042 1277.71 249.002 1339.39 249.002C1401.06 249.002 1451.05 199.042 1451.05 137.412H1395.22C1395.22 168.227 1370.22 193.207 1339.39 193.207Z",
    fill: "#F4F4F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.064 25.8215V-29.9734L556.567 -29.9734V25.8215L724.064 25.8215Z",
    fill: "#F4F4F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M779.896 109.513C779.896 94.1057 792.394 81.6166 807.812 81.6166C823.23 81.6166 835.728 94.1057 835.728 109.513C835.728 124.922 823.23 137.411 807.812 137.411C792.394 137.411 779.896 124.922 779.896 109.513Z",
    fill: "#F4F4F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1114.89 165.309C1114.89 149.901 1127.39 137.412 1142.81 137.412C1158.23 137.412 1170.72 149.901 1170.72 165.309C1170.72 180.717 1158.23 193.207 1142.81 193.207C1127.39 193.207 1114.89 180.717 1114.89 165.309Z",
    fill: "#F4F4F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1338.22 53.7191C1338.22 38.3114 1350.72 25.8222 1366.14 25.8222C1381.56 25.8222 1394.06 38.3114 1394.06 53.7191C1394.06 69.128 1381.56 81.6171 1366.14 81.6171C1350.72 81.6171 1338.22 69.128 1338.22 53.7191Z",
    fill: "#F4F4F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M835.728 -85.7683C835.728 -116.583 860.725 -141.563 891.56 -141.563V-197.358C829.889 -197.358 779.895 -147.398 779.895 -85.7683C779.895 -24.1386 829.889 25.8215 891.56 25.8215V-29.9734C860.725 -29.9734 835.728 -54.9535 835.728 -85.7683Z",
    fill: "#F4F4F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1003.23 81.6164C1003.23 112.431 978.23 137.411 947.394 137.411V193.206C1009.07 193.206 1059.06 143.246 1059.06 81.6164C1059.06 19.9868 1009.07 -29.9733 947.394 -29.9733V25.8215C978.23 25.8215 1003.23 50.8016 1003.23 81.6164Z",
    fill: "#F4F4F5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_49233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 408,
    fill: "white",
    transform: "translate(0 -159)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageHeroHeader);
export default __webpack_public_path__ + "static/media/Homepage-Hero-Header.e1d19273684da1bfc4a337ee9bec625d.svg";
export { ForwardRef as ReactComponent };